/** @file guideTopics: the server's guide topic names (`GET /api/v1/guides`). */

/** The guide topic names of the server at `url`; throws on a non-2xx status. */
export async function guideTopics(url: string, fetchFn: typeof fetch = fetch): Promise<string[]> {
  const res = await fetchFn(`${url.replace(/\/+$/, '')}/api/v1/guides`, { credentials: 'include' });
  if (!res.ok) throw new Error(`guides: HTTP ${String(res.status)}`);
  return ((await res.json()) as { topics: string[] }).topics;
}
